    <template>
    
  <div id="edit-personal-info">
    <!-- Success Alert -->
  <v-dialog
      v-model="alert"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{'emp._Saved_info_'|translate}}</v-card-title>
      
        <v-card-text>
          {{'emp._part1_save_emp_'|translate}} {{this.form.firstName}} {{'emp._access_code_info_'|translate}} <h4 class="text-xs-center">{{this.form.accessCode}}</h4>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="alert = false"
          >
            {{'general._ok_'|translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- child dialog -->
    <v-dialog v-model="showChildren" persistent max-width="500">
         <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-side-icon><v-icon @click="showChildren = false">close</v-icon></v-toolbar-side-icon>

          <v-toolbar-title>{{'emp._child_15_'|translate}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
       <form @submit.prevent="validateChildInfo">
         <v-container>
        <v-flex xs12>
          <v-text-field
            :label="$t('emp._firstname_')"
          type="text"
          v-model="infant.firstName"
          required>
          </v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-text-field
          :label="$t('emp._lastname_')"
          type="text"
          v-model="infant.lastName"
          required
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
         <v-text-field
           :label="$t('emp._postname_')"
          type="text"
          v-model="infant.posteName"
          ></v-text-field>
        </v-flex>
           <v-flex xs12>
                <br>
                  <label>{{'emp._dateofBirth_'|translate}}}</label>
                      <v-menu
                      ref="childmenu"
                      :close-on-content-click="false"
                      v-model="childmenu"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      nax-width="290px"
                    >
                  
                      <v-text-field
                        slot="activator"
                        v-model="infant.dateOfBirth"
                        label="Date de naissance aaaa-mm-jj"
                        append-icon="event"
                        readonly
                        solo
                      ></v-text-field>
                      <v-date-picker
                        ref="picker"
                        v-model="infant.dateOfBirth"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1900-01-01"
                        @change="childsave"
                      ><v-spacer></v-spacer>
                <v-btn flat color="primary" @click="childmenu = false">  {{'general._cancel_'|translate}}</v-btn>
                <v-btn flat color="primary" @click="$refs.childmenu.save(childmenu)">  {{'general._ok_'|translate}}</v-btn></v-date-picker>
                    </v-menu>
                        </v-flex>
                         <v-flex xs12>
                          <v-text-field label="Combien d'enfants au-dessus de 15 ans avez-vous?" 
                          type="number" min="0"
                          v-model.number="form.numberOfKids"
                          required></v-text-field>
                        </v-flex>
      <v-flex xs12 sm12>
        <v-layout row>
        <br>
        <v-btn color="primary" @click="showChildren = false">  {{'general._close_'|translate}}</v-btn>
        <v-spacer></v-spacer>
        <v-btn type="submit" color="success">  {{'general._save_'|translate}}</v-btn>
        </v-layout>
      </v-flex>
         </v-container>
       </form>
      </v-card>
       </v-flex>
         </v-layout>
    </v-dialog>
                    <v-dialog v-model="showPhone" persistent max-width="500px">
                       <v-layout row>
              <v-flex xs12>
                      <v-card>
                        <form @submit.prevent="validatePhoneInfo">
                      <v-toolbar card prominent dense color="primary" dark="">
              <v-toolbar-title class="subheading">{{'emp._phone_info_'|translate}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showPhone = false">
                  <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
             <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
 <!--         <v-flex xs12>
        
           <label for="noPhoneReason">Pour quel raison vous n'avez pas un telephone intelligent</label>
        <v-select id="noPhoneReason"
        v-model="form.noPhoneReason"
        :rules="[rules.required]"
        :items="['Coût d\'achat trop cher', 'Coût d\'utilisation trop cher', 'Coût achat et utilisation trop cher', 'Ne sait pas comment utiliser un telephone']">
        </v-select>
         </v-flex> -->
                 <v-flex xs12>
                  <label>{{'members._phone_sale_'|translate}}</label>
                <v-radio-group v-model="form.isBuyPhoneReady"
                :rules="[rules.required]"
                row>
                <v-radio :label="$t('general._yes_')" :value="true">{{'general._yes_'|translate}}</v-radio>
                <v-radio :label="$t('general._yes_')" :value="false">{{'general._no_'|translate}}</v-radio>
                </v-radio-group>
                 </v-flex>
                      </v-layout>
                    </v-container>
             </v-card-text>
       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn type="submit" color="blue darken-1">  {{'general._close_'|translate}}</v-btn>
       </v-card-actions>
       </form>
       </v-card>
              </v-flex>
                       </v-layout>
    </v-dialog>

              <!-- phoneDialog end -->

                <!-- photo Dialog -->
              <!-- <v-dialog v-model="photoDialog" persistent max-width="500px">
                <v-card>
                   <v-toolbar card prominent dense color="primary" dark="">
              <v-toolbar-title class="subheading">Ajouter une photo</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="photoDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>   
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12>
                        </v-flex>
                       <video ref="video" class="camera-stream"/>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="photoDialog = false">Terminer</v-btn>
                    <v-btn icon>
                    <v-icon @click="capture">add_a_photo</v-icon>
                  </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog> -->

              <!-- Main page -->
    <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
     <v-toolbar>
     <v-toolbar-title>
       <v-list-tile>
        <v-list-tile-avatar size="50">
               <img v-on:click="photoDialog" style="cursor:pointer" v-bind:src="imageUrl"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{form.firstName}} {{form.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{'members._access_code_'|translate}}: {{ this.form.accessCode }} id {{this.member_id}} </v-list-tile-sub-title>
              </v-list-tile-content>
       </v-list-tile>
    </v-toolbar-title>
     <v-spacer></v-spacer>
      <v-flex xs12 sm6>
        <br><label>{{'members._per_info_con_'|translate}}</label>
          <v-checkbox
          v-model="form.consent"
          label="Accepter"
          readonly
          ></v-checkbox>
      </v-flex>
       
  </v-toolbar>
    
      <v-card class="mb-5">
        <v-form @submit.prevent="validateMember">
        <v-card-title>
             <v-layout row wrap>

        <v-flex xs12 sm4>
                 <v-text-field 
                 :label="$t('emp._firstname_')"
                 name="prénom"
                 :error-messages="errors.collect($t('emp._firstname_'))"
                 id="firstName"
                 v-validate="'required'"
                 autocomplete="given-name"
                 v-model="form.firstName">
              </v-text-field>
        </v-flex>
        <v-flex xs12 sm4>
              <v-text-field 
              :label="$t('emp._lastname_')"
              name="nom de famille"
              id="lastName"
              autocomplete="family-name"
              :error-messages="errors.collect('nom de famille')"
               v-validate="'required'"
              v-model="form.lastName">
              </v-text-field>
        </v-flex>

          <v-flex xs12 sm4>
              <v-text-field 
              :label="$t('emp._postname_')"
              name="poste nom"
              id="lastName"
              autocomplete="family-name"
              v-model="form.posteName">
              </v-text-field>
        </v-flex>

      <v-flex xs12 sm4>
          <v-menu
    ref="menu"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="form.dateOfBirth"
      name="Date de naissance"
      :error-messages="errors.collect('Date de naissance')"
      v-validate="'required'"
     :label="$t('emp._dateofBirth_')"
      prepend-icon="event"
      readonly
      solo
    ></v-text-field>
    <v-date-picker
      ref="picker"
      v-model="form.dateOfBirth"
      :max="new Date().toISOString().substr(0, 10)"
      min="1950-01-01"
      @change="save"
    ></v-date-picker>
  </v-menu>
      </v-flex>
          <v-flex xs12 sm3>
               <label>
                 {{'emp._sex_'|translate}} : {{form.gender}}</label>
                 <v-radio-group v-model="form.gender"
                 name="Sexe"
                 :error-messages="errors.collect('Sexe')"
                 v-validate="'required'" row>
                <v-radio :label="$t('emp._man_')" :value="$t('emp._man_')"></v-radio>
                <v-radio :label="$t('emp._women_')" :value="$t('emp._women_')"></v-radio>
                </v-radio-group>
          </v-flex>
            <v-flex xs12 sm5>
           <label id="maritalStatus">{{'emp._matrial_status_'|translate}}: {{ form.maritalStatus }}</label>
                <v-radio-group v-model="form.maritalStatus"
                name="Etat Civil"
                 :error-messages="errors.collect('Etat Civil')"
                 v-validate="'required'"
                 row>
                <v-radio  :label="$t('emp._single_')" :value="$t('emp._single_')"></v-radio>
               <v-radio   :label="$t('emp._Married_')" :value="$t('emp._Married_')"></v-radio>
               <v-radio   :label="$t('emp._Divorced_')" :value="$t('emp._Divorced_')"></v-radio>
               <v-radio   :label="$t('emp._Widower_')" :value="$t('emp._Widower_')"></v-radio>
                </v-radio-group>
            </v-flex>
             <v-flex xs12 sm3> 
          <v-select 
          v-model="form.role"
          name="rôle"
          :error-messages="errors.collect('rôle')"
          v-validate="'required'"
          label="Rôle"
          id="role"
          :items="[$t('emp._Faithful_'),$t('emp._Choristers_'),$t('emp._Youth_'),$t('emp._Masanga_'),$t('emp._Servant_of_God_')]">
          </v-select>
        </v-flex>
             <v-flex xs12 sm3>
              {{'emp._school_level_'|translate}}
        <v-select
          v-model="form.niveauScolaire"
          :items="[$t('emp._school_level1_'),$t('emp._school_level2_'),$t('emp._school_level3_'),$t('emp._school_level4_'),$t('emp._school_level5_')]"
          name="niveau scolaire"
          :error-messages="errors.collect('niveau scolaire')"
          v-validate="'required'"
          solo
        ></v-select>
          </v-flex>
              <v-flex xs12 sm3>
                  <v-text-field validate autocomplete="phone" 
                    type="tel" 
                    v-model="form.phone"
                    :label="$t('emp._phone_')"
                    prepend-icon="mdi-city"
                    name="telephone"
                    placeholder="## - ### - ## - ##"
                    :error-messages="errors.collect('telephone')"
                    v-validate="'required'"
                    :mask="telephone"
                    hint="01 234 56 78"
                    persistent-hint
                ></v-text-field>                
              </v-flex>
          <v-flex xs12 sm3>
          <v-text-field  :label="$t('emp._email_')"
          type="email"
          name="email"
          id="email"
          :error-messages="errors.collect('email')"
          v-validate="'required|email'"
          autocomplete="email"
          v-model="newEmail"
          readonly>
          </v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
             {{'coupons._cop_city_'|translate}} 
            <v-combobox
           v-model="form.city"
            :items="areas"
            name="commune"
            :error-messages="errors.collect('commune')"
            v-validate="'required'"
            solo
        ></v-combobox>
          </v-flex>
          <v-flex xs12 sm4>
                {{'coupons._cop_region_'|translate}} 
            <v-combobox
            v-model="form.postalCode"
            :items="zones"
            name="quartier"
            :error-messages="errors.collect('quartier')"
            v-validate="'required'"
            solo>
              </v-combobox>
          </v-flex>
           <v-flex xs12 sm4>
           {{'coupons._cop_civic_'|translate}}
            <v-text-field
            type="text"
            :label="$t('coupons._cop_civic_')"
            v-model="form.address"
            name="addresse"
            :error-messages="errors.collect('addresse')"
            v-validate="'required'"
            solo>
          </v-text-field>
            </v-flex>
              <v-flex xs12 sm4 v-show="editMode">
                <span><h4>Enfants</h4></span>
      <v-btn @click="showKids = true">
        <v-icon>menu</v-icon>
        <v-tooltip>Enfants</v-tooltip>
      </v-btn>
              </v-flex>
            <v-flex xs12 sm4 v-show="!editMode">
           <label id="hasChildren" for="hasChildren">{{'members._child_qs_'|translate}}</label>
                <v-radio-group v-model="form.hasChildren" row>
                <v-radio  :label="$t('general._yes_')" v-on:change="showChildren = true" :value="true"></v-radio>
                <v-radio  :label="$t('general._no_')" :value="false"></v-radio>
                </v-radio-group>
            </v-flex>
                <v-flex xs12 sm4>
                  <label id="isWithChildren" for="isWithChildren">{{'members._child_preach_'|translate}}</label>
               
                <v-radio-group v-model="form.isWithChildren" row>

                <v-radio  :label="$t('general._yes_')" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" :value="false"></v-radio>
                </v-radio-group>
                </v-flex>
                <v-flex xs12 sm4>
                    <label id="hasSmartPhone" for="hasSmartPhone">{{'members._smart_phone_'|translate}}</label>
                  
                    <v-radio-group
                    name="possède un cellulaire"
                    :error-messages="errors.collect('possède un cellulaire')"
                    v-validate="'required'"
                    v-model="form.hasSmartPhone" 
                    row>
                <v-radio  :label="$t('general._yes_')" :value="true"></v-radio>
                <v-radio  :label="$t('general._no_')" v-on:change="showPhone = true" :value="false"></v-radio>
                </v-radio-group>

                </v-flex>

                    <v-flex xs12 sm4>
        <v-btn  color="primary" @click="create_qr_code" >{{'coupons._cop_Qr_code_'|translate}}</v-btn>
          <!-- 	<v-text-field label="write your Qr code text"  v-model="message"></v-text-field> -->
             <qr-code ref="qr_code" :text="message" @change="onFilePicked_image_bar_code" id="qr_code"></qr-code>
               <v-btn  v-if="message != ''" color="primary" @click="onFilePicked_image_bar_code" >{{'coupons._cop_save_Qr_code_'|translate}}</v-btn>
				</v-flex>
             

             </v-layout>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" color="primary" required>{{'general._save_'|translate}}</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>             
        <v-card-actions>
        </v-card-actions>
          <v-card-actions style="display:inline">
          <router-link v-show="editMode" :to="{ name: 'Dashboard', params: { job_id: this.member_id }}"><v-btn color="primary">  {{'general._back_'|translate}}</v-btn></router-link>
        </v-card-actions>
    </v-layout>
          </v-container>
          </div>
          </template>
<script>
/* eslint-disable */
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";
import fr from "vee-validate/dist/locale/fr";
import firebase from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import { db } from "@/api/firebaseInit";
import { auth,storage } from "@/api/firebaseInit";
Validator.localize("fr", fr);
export default {
  name: "edit-personal-info",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
       date: null,
        modal: false,
       message:'',
      Download_bar_code_url:'',
      telephone: "## - ### - ## - ##",
      isPhotoTaken: false,
      alert: false,
      mediaStream: null,
      sending: false,
      showPhone: false,
      editMode: false,
      showChildren: false,
      zones: quartiers,
      areas: communes,
      createdBy: null,
      createdById: null,
      menu: false,
      childmenu: false,
      rules: {
          required: value => !!value || 'Ce champs est obligatoire.',
      },
/*       form: {
         firstName: null,
         lastName: null,
         posteName: null,
         gender: "Femme",
         dateOfBirth: null,
         consent: null,
         email: null,
         phone: null,
         accessCode: "",
         niveauScolaire: "École Secondaire",
         maritalStatus: "Marié(e)",
         address: "",
         city: "",
         role: "",
         postalCode: "",
         numberOfKids: 0,
         hasChildren: "Non",
         isWithChildren: "Non",
         isBuyPhoneReady: "Non",
        noPhoneReason: "Coût d'achat trop cher",
         hasSmartPhone: "Oui",
         imageUrl: this.imageUrl,
         volunteerTime: {
         amount: 0,
         frequency: ''
           },
         dime: {
           type: '',
           frequency: '',
           nombre: 0
         },
         offrande: {
           type: '',
           frequency: '',
           nombre: 0
         },
         houseOwnerSince: {
           frequency: '',
           nombre: 0
         },
         education: {
           frequency: '',
           nombre: 0
         },
          isWorking: "Non",
         isWorkReady: "Non",
          isJobSearching: "Non",
          isEducationReady: "Non",
         notAvailableReason: 'Non disponible',
          isHouseOwner: "Non",
         isRenting: "Non",
          jobSkills: null,
         jobSearch: {
           amount: 1,
           frequency: "mois"
         },
         jobType: null,
         availableTime: 0,
         jobDisponibility: {
           amount: 1,
           frequency: "Par mois"
         },
          timeOnCurrentJob: {
           amount: 6,
           frequency: "mois"
         },
         jobPosition: null,
         numberOfJobs: 1,
         jobRepartition: "Temps plein",
         jobWeeklyHours: 40,
         jobTravelTime: {
           hours: 0,
           minutes: 30
         },
         jobTravelDistance: "plus de 30 km",
         jobTravelMode: "Vélo",
         jobTravelCost: 0,
         jobMonthlyPay: 10,
          isDonationReady: "Non",
         noDonationReason: "Pas prêt à contribuer",
         isDimeContribution: "Non",
         donation: {
           amount: 0,
           frequency: "Par mois",
         },
         dime: {
           nombre: 0,
           frequency: "Par jour",
         },
         dimeType: 'Nature',
         isOffrandeContribution: "Non",
         offrandeType: 'Nature',
         offrande: {
           nombre: 0,
           frequency: "Par semaine",
         },
         isGraceContribution: "Non",
         graceContributionType: 'Nature',
         churchName: null,
         memberSince: '1 à 3 ans',
         churchAttendance: null,
         sermonTimeSpent: 0,
         isreferralReady: "Non",
         noReferralReason: 'Pas de références',
         isVolunteerReady: "Non",
         noVolunteerReason: "Raison personelle",
       }, */
      infant: {
        dateOfBirth: null,
        firstName:'',
        lastName: '',
        posteName: ''
      },
    };
  },
   created() {
    this.$validator.localize("fr", this.dictionary);
    this.createdBy = auth.currentUser.displayName;
     
    this.createdById = auth.currentUser.uid;
  },
  computed: {
    form () {
      let member = this.$store.getters.getCurrentMember;
       this.member_id = member.id
        return member
    },
    newEmail() {
      let email = this.form.firstName + this.form.lastName + "@mosala.work";
      email = email.replace(/\s+/g, "");
      return email;
    },
    imageUrl() {
      return this.$store.getters.memberPhoto;
    }
  },
  watch: {
     form (val) {
      this.$store.commit('currentMember', val)
    }, 
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    childmenu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
      onFilePicked_image_bar_code () {
  console.log("here in qr code")
        var blob="";
       var that = this
      
         var someimage = document.getElementById('qr_code');
         var myimg = someimage.getElementsByTagName('img')[0];
          var mysrc = myimg.src;
    
  var block = mysrc.split(";");
// Get the content type of the image
var contentType = block[0].split(":")[1];// In this case "image/gif"
// get the real base64 content of the file
var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."
// Convert it to a blob to upload
var blob = this.b64toBlob(realData, contentType);
       
     // Upload file and metadata to the object 'images/mountains.jpg'
var uploadTask = storage.ref().child(`census/${this.member_id}/qr_code/file_${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
  //  console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
       // console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
      //  console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
   console.log('File available at bar code', downloadURL);
    that.saveImageUrl_bar_code(downloadURL)
          
             downloadURL=''
             blob=''    
  });
});
    },
          saveImageUrl_bar_code (url) {
           this.loading = false;
           this.Download_bar_code_url=url;
            console.log("url bar code",this.Download_bar_code_url)
        },

        create_qr_code() {
  this.message ="";
  this.message =this.member_id
},

 b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
},

    save(dateOfBirth) {
      this.$refs.menu.save(dateOfBirth);
    },
    childsave(dateOfBirth) {
      this.$refs.menu.save(dateOfBirth);
    },
    fetchData () {
       this.$bind('form', db.colection('Census').doc(this.member_id))
        if (this.form.imageUrl === "./src/assets/avatar.png" ) {
           form.imageUrl = memberPhoto;
         }
         if (
          this.form.isBuyPhoneReady === null ||
          this.form.isBuyPhoneReady === undefined
         ) {
           form.isBuyPhoneReady = false;
         }
         if (
          this.form.isVolunteerReady === null ||
          this.form.isVolunteerReady === undefined
         ) {
           form.isVolunteerReady = false;
         }
         if (
          this.form.volunteerTime === null ||
          this.form.volunteerTime === undefined
         ) {
           form.volunteerTime.amount = 0;
           form.volunteerTime.frequency = 'Par jour';
         }
          if (
          this.form.houseOwnerSince === null ||
          this.form.houseOwnerSince === undefined
         ) {
           form.houseOwnerSince = {
            amount: 0,
            frequency: 'Par semaine'
           }
          }
         if (
          this.form.education === null ||
          this.form.education === undefined
         ) {
          form.education = {
            amount: 0,
            frequency: 'Par semaine'
           }
         }
         if (
          this.form.numberOfKids === null 
         // || this.form.noPhoneReason === null
         ) {
           form.numberOfKids = 0;
         }
         if (
          this.form.noReferralReason === null ||
          this.form.noReferralReason === undefined
         ) {
           form.noReferralReason = 'Pas de raison';
         }
         if (
          this.form.noDonationReason === null ||
          this.form.noDonationReason === undefined
         ) {
           form.noDonationReason = 'Pas de raison';
         }
    },
    validateChildInfo() {
        if (this.infant.dateOfBirth === null || this.infant.dateOfBirth === undefined ) {
           alert(`la date de naissance de l'enfant`)
          return;
        } else {
          this.saveChildInfo()
        }
    },
    validatePhoneInfo() {
      //this.form.noPhoneReason === null ||
        if ( this.form.isBuyPhoneReady === null || this.form.isBuyPhoneReady === undefined) {
          return;
        } else {
          this.showPhone = false
        }
    },
    validateMember() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.savePersonalInfo();
        } else {
          return;
        }
      });
    },
    saveChildInfo() {
       var childAge = new Date(this.infant.dateOfBirth);
         childAge.setHours(0, 0, 0, 0)
         this.infant.dateOfBirth = childAge
      db.collection('Census').doc(this.member_id).collection("Children")
        .add({
          firstName: this.infant.firstName,
          lastName: this.infant.lastName,
          dateOfBirth: new Date(this.infant.dateOfBirth),
          parentID: this.member_id
        })
        .then(() => {
          alert(`${this.infant.firstName} ${this.infant.lastName} a été enregistré(e)`);
         this.infant = {}
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    savePersonalInfo() {
      var type=''
      if(this.form.role=='SS'){
        type='S'}
      else if(this.form.role=='MC') {
        type='MC'
      }
      var data = {}
      const memberRef = db.collection("Census").doc(this.member_id);
      this.form.email = this.newEmail;
      if (this.form.hasChildren === false) {
        this.form.numberOfKids = 0;
      }
      if (this.form.hasSmartPhone === true) {
        this.form.isBuyPhoneReady = false;
        //this.form.noPhoneReason = '';
      }
      if (this.form.posteName === "" || this.form.posteName === undefined) {
        this.form.posteName = null;
      }
       data = {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          lowerAccessCode: this.form.accessCode.toLowerCase(),
          lowerLastName: this.form.lastName.toLowerCase(),
          posteName: this.form.posteName,
          dateOfBirth: new Date(this.form.dateOfBirth),
          phone: this.form.phone,
          consent: this.form.consent,
          address: this.form.address,
          city: this.form.city,
          role: this.form.role,
          type:type,
          numberOfKids: this.form.numberOfKids,
          gender: this.form.gender,
          email: this.form.email,
          postalCode: this.form.postalCode,
          hasChildren: this.form.hasChildren,
          createdDate: new Date(),
          isWithChildren: this.form.isWithChildren,
          hasSmartPhone: this.form.hasSmartPhone,
          isBuyPhoneReady: this.form.isBuyPhoneReady,
         // noPhoneReason: this.form.noPhoneReason,
          maritalStatus: this.form.maritalStatus,
          niveauScolaire: this.form.niveauScolaire,
          imageUrl: this.imageUrl,
          createdById: this.createdById,
          createdBy: this.createdBy };
          
      if(this.Download_bar_code_url != "") {
         data.qr_url= this.Download_bar_code_url
       }

      memberRef
        .update(data)
        .then(() => {
          this.alert = true;
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    photoDialog() {
      // if (this.imageUrl === '/static/avatar/avatar.png') {
      // this.showPictDialog = true
      // }
      this.$router.push("/appphoto");
    }
  }
};
</script>
<style scoped>
.camera-stream {
  width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/form/steppers/EditPersonalInfo.vue